const actions = {
    FETCH_SUBSTITUTES: 'FETCH_SUBSTITUTES',
    FETCH_SUBSTITUTE_REPORTS: 'FETCH_SUBSTITUTE_REPORTS',
    FETCH_SUBSTITUTE: 'FETCH_SUBSTITUTE',
    FETCH_SUBSTITUTE_ROUTINE: 'FETCH_SUBSTITUTE_ROUTINE',
    RESET_SUBSTITUTE: 'RESET_SUBSTITUTE',
    RESET_SUBSTITUTE_ROUTINE: 'RESET_SUBSTITUTE_ROUTINE',
    FETCH_SUBSTITUTE_TEACHER_PERIODS: 'FETCH_SUBSTITUTE_TEACHER_PERIODS',

    fetchSubstitutesAction: (data) => {
        return {
            type: actions.FETCH_SUBSTITUTES,
            data: data
        };
    },
    fetchSubstituteReportsAction: (data) => {
        return {
            type: actions.FETCH_SUBSTITUTE_REPORTS,
            data: data
        };
    },
    resetSubstituteFormAction: () => {
        return {
            type: actions.RESET_SUBSTITUTE,
            data: null
        };
    },
    resetSubstituteRoutineFormAction: () => {
        return {
            type: actions.RESET_SUBSTITUTE_ROUTINE,
            data: null
        };
    },
    fetchSubstituteAction: (data) => {
        return {
            type: actions.FETCH_SUBSTITUTE,
            data: data
        };
    },
    fetchSubstituteTeacherPeriodsAction: (data) => {
        return {
            type: actions.FETCH_SUBSTITUTE_TEACHER_PERIODS,
            data: data
        };
    },
    fetchSubstituteRoutineAction: (data) => {
        return {
            type: actions.FETCH_SUBSTITUTE_ROUTINE,
            data: data
        };
    },
};

export default actions;
